import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { HasPortalAccess } from '../contexts';

export default function ProtectedRoute({ children }) {
  const { hasPortalAccess } = useContext(HasPortalAccess);
  const location = useLocation();
  
  // Check if this is a portal switch request
  const urlParams = new URLSearchParams(location.search);
  const portalSwitch = urlParams.get('portal-switch');
  
  console.log('ProtectedRoute: hasPortalAccess:', hasPortalAccess);
  console.log('ProtectedRoute: portalSwitch:', portalSwitch);
  
  // If portal-switch=1, allow access regardless of hasPortalAccess
  if (portalSwitch === '1') {
    return children;
  }
  
  // Otherwise, use normal protection logic
  return hasPortalAccess ? children : <Navigate to="/" />;
}
